// project import
import useAuth from 'hooks/useAuth';

// material-ui
import { Box, Dialog, DialogTitle, IconButton, Theme, useTheme, Typography } from '@mui/material';

// assets
import CancelTwoToneIcon from '@mui/icons-material/CancelTwoTone';


// ==============================|| HEADER PROFILE - PROFILE TAB ||============================== //

interface Props {
  open: boolean,
  onClose(): void,
}

const ContactDialog = ({ open, onClose }: Props) => {
  const { user } = useAuth();
  const theme = useTheme();

  if (!!!user)
    return (<></>);
  else
    return (
      <Dialog open={open} maxWidth="sm" fullWidth>
        <DialogTitle id="form-pricelist-lookup-dialog-title">Contact {user?.dmsCompany}</DialogTitle>
        <Box sx={{ ml: 'auto', mt: -7, pr: 1 }}>
          <IconButton disableRipple aria-label="Close Contact" color="primary" onClick={() => onClose()} size="medium">
            <CancelTwoToneIcon />
          </IconButton>
        </Box>
        <Typography variant="h6" sx={{ m: 3 }}>
          Please contact {user?.dmsCompany} at <a style={{ color: theme.palette.mode === 'dark' ? 'lightblue' : 'blue' }} href={user?.dmsCompany === 'Ideal' ? 'mailto:PriceLists@IdealComputerSystems.com' : 'mailto:Pricing@cSystemsSoftware.com'}>{user?.dmsCompany === 'Ideal' ? 'PriceLists@IdealComputerSystems.com' : 'Pricing@cSystemsSoftware.com'}</a>&nbsp;
          if you are unsure which price list you need or if you do not see the price list you would like to order.<br />
          <br />
        </Typography>
      </Dialog>
    );
};

export default ContactDialog;
